import sliceCreator from '../../index.jsx';
import {GET_DISTRICT_BY_ID} from '../../../constants/index.jsx';
const _getDistrictByIdAction = sliceCreator('GET_DISTRICT_BY_ID', GET_DISTRICT_BY_ID, 'get');

const { asyncAction: getDistrictByIdAction, reducer, clearData: clearGetDistrictByIdAction } = _getDistrictByIdAction;

export default reducer;

export {
    getDistrictByIdAction,
    clearGetDistrictByIdAction
}